import React, { useEffect, useState, useContext, useCallback, useMemo, useRef } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";

import { getAuthorizationToken } from "@/auth/tokenStore";
import DepartmentPanelLitigation from "@/Components/LitigationDashboard/new-components-litigation/department-panel-litigation";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarLitigation from "../Components/LitigationDashboard/ActionBarLitigation";
// import LitigationCase from "../Components/LitigationDashboard/litigationCase";
// import LitigationDefendant from "../Components/LitigationDashboard/litigationDefendantTable";
// import LitigationCourtInfo from "../Components/LitigationDashboard/LitigationCourtDetail";
// import LitigationJudgeInfo from "../Components/LitigationDashboard/LitigationJudgeDetail";
import LitigationTab from "../Components/LitigationDashboard/LitigationsTabs";
import { getClientId, getCaseId, fetchShakespeareStatus, fetchPageObject } from "../Utils/helper";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import { ClientDataContext } from "../Components/ClientDashboard/shared/DataContext";
import LitigationTimeLines from "../Components/LitigationDashboard/LitigationTimelines";
import Footer from "../Components/common/footer";
import { fetchStates } from "../Redux/states/statesSlice";
// import LitigationActionTabs from "../Components/LitigationDashboard/LitigationActionTabs";
import CourtHistoryTable from "../Components/LitigationDashboard/CourtHistoryTable";
import AddLitigationActPopup from "../Components/LitigationDashboard/Modals/AddLitigationActPopup";
import { api_without_cancellation } from "../api/api";
import { TemplatesLitigationModal } from "../Components/LitigationPageModal/TemplatesLitigationModal";
import { DiscoveryLitigationModal } from "../Components/LitigationPageModal/DiscoveryLitigationModal";
import { NoTemplateModal } from "../Components/LitigationPageModal/NoTemplateModal";
import CourtFormPageTable from "../Components/LitigationPageModal/CourtFormPageTable";
import { DiscoveryEditModal } from "../Components/LitigationPageModal/DiscoveryEditModal";
import { useFooter } from "../Components/common/shared/FooterContext";
// import DefendantPlaintiffBlock from "../Components/LitigationDashboard/DefendantPlaintiffBlock";
import LitigationActSummaryTable from "../Components/LitigationDashboard/LitigationActSummaryTable";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import addIconGold from "../assets/Add-icon-gold.svg";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import CaseTabLitigation from "../Components/LitigationDashboard/new-components-litigation/case-panel-litigation";
import CourtPanelLitigation from "../Components/LitigationDashboard/new-components-litigation/court-panel-litigation";
import JudgePanelLitigation from "../Components/LitigationDashboard/new-components-litigation/judge-panel-litigation";
import DefendantServicePanel from "../Components/LitigationDashboard/new-components-litigation/defendant-service-panel";
import DefendantBlockPanel from "../Components/LitigationDashboard/new-components-litigation/defendant-block";
import PlainTiffBlock from "../Components/LitigationDashboard/new-components-litigation/plaintiff-block";
import "./litigationPage.css";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import PageDocsTab, { createDocsTab } from "../Components/DocPage/new-tab/page-docs-tab";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";

function LitigationPage() {
  const [showActPopup, setShowActPopup] = useState(false);
  const [documentDraft, setDocumentDraft] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [discoveryData, setDiscoveryData] = useState(null);
  const [docDetails, _setDocDetails] = useState({ docId: null, docName: "" });
  const [draftID, setDraftID] = useState(null);
  const [templateStatus, setTemplateStatus] = useState({});
  const { setFooterState } = useFooter();
  const [isBlocked, setIsBlocked] = useState(false);
  const origin = process.env.REACT_APP_BACKEND_URL;
  const token = getAuthorizationToken();
  const currentCaseId = getCaseId();
  const clientId = getClientId();
  const [litigationData, setLitigationData] = useState({});
  const [defendantsData, setDefendantsData] = useState([]);
  const [DefendantProcessedPageSlots, setDefendantProcessedPageSlots] = useState([]);
  const [firstTimeLitigationtData, setFirstTimeLitigationData] = useState(true);
  const dispatch = useDispatch();
  const [eventTypesData, setEventTypesData] = useState([]);
  const {
    isLitigationDashboardDataUpdate,
    setLitigationDashboardDataUpdated,
    isLitigationActDataUpdated,
  } = useContext(ClientDataContext);
  const [pageObject, setPageObject] = useState(null);

  dispatch(fetchStates());

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 19).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  const handleOpenModal = (type, label, icon) => {
    setModalData({ type, label, icon });
  };

  const handleCloseModal = () => {
    setModalData(null);
    setDiscoveryData(null);
  };

  const handleClosePopup = useCallback(() => {
    if (showActPopup === true) {
      setShowActPopup(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showActPopup]);

  const [litigationTab, setLitigationTab] = useState("case");
  const isMediaTab = litigationTab === "docs" || litigationTab === "photo";
  const handleTabChange = (tab) => {
    setLitigationTab(tab);
    if (tab !== "courtForms") {
      getDocumentDraft();
      getButtonConfigurations();
    }
  };
  // const tabsData = [
  //   {
  //     id: "case",
  //     label: "Case",
  //     onClick: () => handleTabChange("case"),
  //     className:
  //       litigationTab === "case"
  //         ? "active tab-trapezium-cycles-corners"
  //         : "tab-trapezium-cycles-corners",
  //     background:
  //       litigationTab === "case" ? "var(--primary) !important" : "var(--primary-5) !important",
  //     rightHand: true,
  //     activeColor: "white",
  //   },
  //   {
  //     id: "court_history",
  //     label: "Venue History",
  //     onClick: () => handleTabChange("court_history"),
  //     className:
  //       litigationTab === "court_history"
  //         ? "active tab-trapezium-cycles-corners"
  //         : "tab-trapezium-cycles-corners",
  //     background:
  //       litigationTab === "court_history"
  //         ? "var(--primary) !important"
  //         : "var(--primary-5) !important",
  //     rightHand: true,
  //     activeColor: "white",
  //   },
  //   {
  //     id: "events",
  //     label: "Litigation Events",
  //     onClick: isBlocked ? null : () => handleTabChange("events"),
  //     className: `${litigationTab === "events" ? "active" : ""} tab-trapezium-cycles-corners ${isBlocked ? "disabled" : ""}`,
  //     background:
  //       litigationTab === "events" ? "var(--primary) !important" : "var(--primary-5) !important",
  //     rightHand: true,
  //     activeColor: "white",
  //     disabled: isBlocked,
  //   },
  //   {
  //     id: "litigation_act",
  //     label: "Litigation Act",
  //     span: <span className="fw-bold pe-2 text-gold">+ </span>,
  //     onClick: () => {
  //       handleTabChange("litigation_act");
  //       setShowActPopup(true);
  //     },
  //     className:
  //       litigationTab === "litigation_act"
  //         ? "active tab-trapezium-cycles-corners"
  //         : "tab-trapezium-cycles-corners",
  //     background:
  //       litigationTab === "litigation_act"
  //         ? "var(--primary) !important"
  //         : "var(--primary-5) !important",
  //     leftHand: true,
  //     activeColor: "white",
  //   },
  //   {
  //     id: "courtForms",
  //     label: "Court Forms",
  //     onClick: () => {
  //       handleTabChange("courtForms");
  //       // handleCourtForm();
  //     },
  //     className:
  //       litigationTab === "courtForms"
  //         ? "active tab-trapezium-cycles-corners"
  //         : "tab-trapezium-cycles-corners",
  //     background:
  //       litigationTab === "courtForms"
  //         ? "var(--primary) !important"
  //         : "var(--primary-5) !important",
  //     rightHand: true,
  //     activeColor: "white",
  //   },
  //   {
  //     id: "discovery_tools",
  //     label: "Document Drafts",
  //     onClick: () => handleTabChange("discovery_tools"),
  //     className:
  //       litigationTab === "discovery_tools"
  //         ? "active tab-trapezium-cycles-corners"
  //         : "tab-trapezium-cycles-corners",
  //     background:
  //       litigationTab === "discovery_tools"
  //         ? "var(--primary) !important"
  //         : "var(--primary-5) !important",
  //     rightHand: true,
  //     activeColor: "white",
  //   },
  // ];

  const mainTabs = useMemo(
    () => [
      {
        id: "case",
        label: "Case",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handleTabChange("case"),
        leftHand: true,
      },
      {
        id: "court_history",
        label: "Venue History",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handleTabChange("court_history"),
        leftHand: true,
      },
      {
        id: "events",
        label: "Litigation Events",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handleTabChange("events"),
        leftHand: true,
      },
      {
        id: "courtForms",
        label: "Court Forms",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handleTabChange("courtForms"),
        leftHand: true,
      },
      {
        id: "discovery_tools",
        label: "Document Drafts",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handleTabChange("discovery_tools"),
        leftHand: true,
      },
    ],
    [handleTabChange]
  );

  const buttonTabs = useMemo(
    () => [
      {
        id: "litigation_act",
        label: "Litigation Act",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        left: "0px",
        onClick: () => setShowActPopup(true),
        leftHand: true,
        span: (
          <span className="fw-bold  ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
          </span>
        ),
      },
    ],
    [handleTabChange]
  );

  const photoTabs = useMemo(
    () => [
      createDocsTab(() => setLitigationTab("docs")),
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => setLitigationTab("photo"),
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              width={15}
              height={15}
              alt=""
            />
          </span>
        ),
      },
    ],
    []
  );

  const getEventType = useCallback(async () => {
    try {
      const response = await axios.get(`${origin}/api/all/event/types/`, {
        headers: {
          Authorization: token,
        },
      });
      setEventTypesData(response.data.data);
    } catch (err) {
      console.error("Error fetching Event Types:", err);
    }
  }, [token, origin]);

  const fetchLitigationData = async (forceRefresh = false) => {
    try {
      const litigation_data = await axios.get(
        `${origin}/api/litigation-page/litigation/?case_id=${currentCaseId}&client_id=${clientId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (litigation_data.status === 200) {
        if (firstTimeLitigationtData) {
          setLitigationData(litigation_data.data);
          setDefendantsData(litigation_data.data?.defendants);
          setDefendantProcessedPageSlots(litigation_data.data?.defendant_processed_page_slots);
          setFirstTimeLitigationData(false);
        }
        if (isLitigationDashboardDataUpdate || forceRefresh) {
          setLitigationData(litigation_data.data);
          setDefendantsData(litigation_data.data?.defendants);
          setDefendantProcessedPageSlots(litigation_data.data?.defendant_processed_page_slots);
          setLitigationDashboardDataUpdated(false);
        }
      }
    } catch (error) {
      console.error("Failed to fetch Litigation Data:", error);
    }
  };

  const CardsData = useMemo(() => {
    const litigation = litigationData?.litigation || {};

    return {
      ...litigation,
      defendants: defendantsData || [],
      litigation_id: litigation?.id || null,
      courtId: litigation?.DirCourt?.id || null,
      departmentId: litigation?.DirDepartment?.id || null,
      judgeId: litigation?.DirJudge?.id || null,
      judge_contact: litigation?.judge_department_contact,
      department_contact: litigation?.clerk_contact,
    };
  }, [litigationData?.litigation]);
  const setTimeLineWidth = () => {
    const timelineRight = document.querySelector("#right-timeline");
    const timelineLeft = document.querySelector(".lit-wrapper-height");

    if (timelineRight && timelineLeft) {
      const timelineLeftHeight = timelineLeft.getBoundingClientRect().height;
      timelineRight.style.height = `${timelineLeftHeight}px`;
    }
  };

  const fetchBlockedStatus = useCallback(async () => {
    try {
      const response = await api_without_cancellation.get(
        `/api/litigation-page/litigation-act-blocked-status/${clientId}/${currentCaseId}/`
      );
      if (response.status === 200) {
        setIsBlocked(response.data.blocked);
      }
    } catch (error) {
      console.error("Error fetching blocked status:", error);
    }
  }, [clientId, currentCaseId, origin]);

  useEffect(() => {
    if (litigationTab === "case") {
      setTimeLineWidth();
      window.addEventListener("resize", setTimeLineWidth);

      // Cleanup to prevent memory leaks
      return () => {
        window.removeEventListener("resize", setTimeLineWidth);
      };
    }
  }, [litigationTab, CardsData]);

  useEffect(() => {
    fetchBlockedStatus();
  }, [clientId, currentCaseId, isLitigationActDataUpdated]);

  useEffect(() => {
    fetchBlockedStatus();
    fetchLitigationData();
    getEventType();
    if (isLitigationDashboardDataUpdate) {
      setLitigationDashboardDataUpdated(false);
    }
    // sending page ids directly now.
    fetchShakespeareStatus(currentCaseId, 19, dispatch);
  }, [clientId, currentCaseId, isLitigationDashboardDataUpdate]);

  useEffect(() => {
    getButtonConfigurations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, currentCaseId]);

  // const [showCourtForm, setShowCourtForm] = useState(false);
  // const [validationText, setValidationText] = useState("");
  // const [validationPopUp, setValidationPopUp] = useState(false);

  // const handleValidationPopUp = () => {
  //   setValidationPopUp(false);
  // };

  // const handleCourtForm = () => {
  //   if (litigationData?.litigation && Object.keys(litigationData?.litigation).length === 0) {
  //     setValidationText("Please select Jurisdiction type and State first.");
  //     setValidationPopUp(true);
  //   } else {
  //     const litigation_states = litigationData?.litigation?.state;

  //     if (litigation_states) {
  //       // setShowCourtForm(true);
  //     } else {
  //       return;
  //     }
  //   }
  // };

  const getButtonConfigurations = async () => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/litigation-page/litigation-event-templates-status/?case_id=${currentCaseId}&client_id=${clientId}`
      );
      if (response.status === 200) {
        const result = response.data;
        setTemplateStatus(result.data);
      } else {
        throw new Error("Failed to fetch data: Unexpected status code");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getDocumentDraft = async () => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/litigation-page/discovery-docs/?case_id=${currentCaseId}&client_id=${clientId}`
      );
      if (response.status === 200) {
        const result = response.data;
        setDocumentDraft(result.data);
      } else {
        throw new Error("Failed to fetch data: Unexpected status code");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const createEditDoc = async (docId, url, docName) => {
    try {
      // Check if docId is present in the currentUrl
      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("url", url);
      formData.append("name", docName);

      const _response = await api_without_cancellation.post(
        `${origin}/api/create-edit-doc/`,
        formData
      );

      // Proceed with additional logic if needed
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleEditButton = async (docId, docName) => {
    const wp_url =
      "/bp-wordprocessor/" +
      getClientId() +
      "/" +
      getCaseId() +
      `/?docId=${docId}&dynamic_template_id=0&type=DiscoveryDraft`;

    await createEditDoc(docId, wp_url, docName);
    window.location.href = wp_url;
  };

  const handleFinalizeButton = async (draftId) => {
    const data = {
      draft_id: draftId,
    };

    try {
      const response = await api_without_cancellation.post(
        `${origin}/api/litigation-page/generate-discovery-doc/`,
        data
      );
      if (response.status === 200) {
        handleCloseModal();
        getDocumentDraft();
      } else {
        console.error(response.statusText);
        alert("Please try again");
      }
    } catch (error) {
      console.error("Error during submit operation:", error);
      alert("Failed to submit the data");
    }
  };

  const handleDeleteButton = async (docId) => {
    try {
      const response = await api_without_cancellation.delete(
        `${origin}/api/litigation-page/discovery-docs/?id=${docId}`
      );
      if (response.status === 200) {
        getDocumentDraft();
        fetchEditDocs();
      } else {
        console.error("Failed to delete document:", response.statusText);
        alert("Failed to submit the data");
      }
    } catch (error) {
      console.error("Error during submit operation:", error);
      alert("Failed to submit the data");
    }
  };

  const fetchEditDocs = async () => {
    try {
      const response = await api_without_cancellation.get(`${origin}/api/create-edit-doc/`);

      if (response.status === 200) {
        const data = response.data;

        setFooterState(data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  const getDiscoveryData = async (draftId) => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/litigation-page/save-interrogatories/?draft_id=${draftId}`
      );
      if (response.status === 200) {
        const result = response.data;
        setDiscoveryData(result);
        setDraftID(draftId);
        handleOpenModal("Interrogatories", null, null);
      } else {
        throw new Error("Failed to fetch data: Unexpected status code");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const buttonConfigs = [
    { type: "Deadline", label: "Deadline Document Templates", icon: "ic-SOL" },
    { type: "Event", label: "Event Document Templates", icon: "ic-Event" },
    { type: "Filing", label: "Filing Document Templates", icon: "ic-Filing" },
    {
      type: "Statute of Limitations",
      label: "S.O.L. Document Templates",
      icon: "ic-SOL",
    },
    {
      type: "Deposition",
      label: "Deposition Document Templates",
      icon: "ic-Deposition",
    },
    { type: "Exam", label: "Exam Document Templates", icon: "ic-Exam" },
    {
      type: "Hearing",
      label: "Hearing Document Templates",
      icon: "ic-Hearing",
    },
    {
      type: "Subpoenas",
      label: "Subpoenas Document Templates",
      icon: "ic-Subpoenas",
    },
    {
      type: "Discovery",
      label: "Discovery Document Templates",
      icon: "ic-Discovery",
      onClick: () => {
        setModalData({
          type: "Discovery",
          label: "Discovery Document Templates",
          icon: "ic-Discovery",
        });
      },
    },
    {
      type: "Expert Discovery",
      label: "Expert Discovery Document Templates",
      icon: "ic-Discovery",
    },
    { type: "Motion", label: "Motion Document Templates", icon: "ic-Motion" },
    { type: "Trial", label: "Trial Document Templates", icon: "ic-Trial" },
  ];

  // const isScreen100 = useMediaQuery({ minWidth: 2300 });
  // const isScreen100Case = useMediaQuery({ maxWidth: 1707 });

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const overviewPanelsRef = useRef(null);
  const showCaseCaption = litigationTab === "courtForms" || litigationTab === "discovery_tools";
  const tabHeading = (
    <div className="litigation-sec-action-bar m-b-5 m-0">
      <div className="d-flex justify-content-center align-items-center height-25">
        <span className="text-center text-uppercase color-white fw-bold">
          {litigationTab === "discovery_tools"
            ? "Litigation Document and Court Form Templates"
            : litigationTab === "courtForms"
              ? "Court Forms Relevant To Venue And Case Type"
              : mainTabs.find((tab) => tab.id === litigationTab)?.label}
        </span>
      </div>
    </div>
  );
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="19" />
          <ActionBarLitigation LitigationDetail={CardsData} pageObj={pageObject} />
          <div className="TreatmentPage-main-container litigation-page-main-container invisible-scrollbar">
            {/* <LitigationActionTabs
                litigationActionTab={litigationTab}
                handleTabChange={handleTabChange}
                tabsData={tabsData}
              /> */}
            <SmartResponsiveTabsContainer
              HandlePage={litigationTab}
              tabsData={mainTabs}
              addTab={buttonTabs}
              photoTab={photoTabs}
              photoTabControlled={true}
              doesHaveAll={false}
            />
            {!showCaseCaption && !isMediaTab && tabHeading}

            <div
              className="litigation-page-scroll-region invisible-scrollbar  w-100"
              // style={{ paddingTop: "5px" }}
            >
              {showCaseCaption && (
                <>
                  <section aria-label="Case Caption" className="litigation-case-caption">
                    <div className="litigation-sec-action-bar d-flex justify-content-center align-items-center height-25 text-uppercase color-white fw-bold">
                      Case Caption
                    </div>
                    <div className="litigation-caption-panels">
                      <PlainTiffBlock BlocksData={CardsData} />
                      <DefendantBlockPanel BlocksData={CardsData} />
                    </div>
                  </section>
                  {tabHeading}
                </>
              )}
              {litigationTab === "case" && (
                <>
                  <div className="litigation-case-dashboard m-b-5">
                    <div className="litigation-case-overview p-r-5">
                      <div className="litigation-grid litigation-case-grid" ref={overviewPanelsRef}>
                        <div className="litigation-item case-item">
                          <CaseTabLitigation caseInfo={CardsData} />
                        </div>
                        <div className="litigation-item court-judge-wrapper">
                          <div className="court-item">
                            <CourtPanelLitigation court={CardsData} />
                          </div>
                          <div className="judge-item">
                            <JudgePanelLitigation Judge={CardsData} />
                          </div>
                          <div className="department-item">
                            <DepartmentPanelLitigation dept={CardsData} />
                          </div>
                        </div>
                      </div>
                      <aside
                        className="litigation-case-timeline p-r-5"
                        aria-label="Litigation Timeline"
                      >
                        <div className="litigation-case-timeline__content">
                          <LitigationTimeLines containerRef={overviewPanelsRef} />
                        </div>
                      </aside>
                    </div>
                    <DefendantServicePanel
                      defendants={defendantsData}
                      defendantProcessedPageSlots={DefendantProcessedPageSlots}
                      fetchLitigationData={fetchLitigationData}
                    />
                    <LitigationActSummaryTable
                      eventTypesData={eventTypesData}
                      CaseData={CardsData}
                      isBlocked={isBlocked}
                      litigation_obj={litigationData?.litigation}
                    />
                  </div>
                  {/* <div className="w-100 m-b-5">
                    
                  </div> */}
                </>
                // <>
                //   <div className="litigation-main-wrapper-responsive flex-nowrap g-0 m-b-5 lit-wrapper-height w-100">
                //     <div className="d-flex-1">
                //       <div className="row g-0 equal-column-wrapper position-relative lit-page-section">
                //         {isScreen100Case ? (
                //           <div className="lit-upper-1 lit-upper-section-child lit-case-block">
                //             <LitigationCase
                //               caseInfo={CardsData}
                //               litigation_obj={litigationData?.litigation}
                //             />
                //           </div>
                //         ) : (
                //           <div className="lit-upper-1 lit-upper-section-child lit-case-block">
                //             <LitigationCase
                //               caseInfo={CardsData}
                //               litigation_obj={litigationData?.litigation}
                //             />
                //           </div>
                //         )}
                //         <LitigationCourtInfo
                //           Court={CardsData}
                //           litigation_obj={litigationData?.litigation}
                //           className="lit-court-block"
                //         />
                //         <LitigationJudgeInfo
                //           Judge={CardsData}
                //           className="lit-judge-block"
                //         />
                //         {isScreen100 ? (
                //           <div
                //             className="d-flex flex-grow-1 flex-column lit-defservice-block"
                //             style={{ rowGap: "5px" }}
                //           >
                //             <LitigationDefendant
                //               defendants={defendantsData}
                //               defendantProcessedPageSlots={DefendantProcessedPageSlots}
                //               fetchLitigationData={fetchLitigationData}
                //               setIsClientDataUpdated={setLitigationDashboardDataUpdated}
                //             />
                //           </div>
                //         ) : (
                //           <>
                //             <LitigationDefendant
                //               defendants={defendantsData}
                //               defendantProcessedPageSlots={DefendantProcessedPageSlots}
                //               fetchLitigationData={fetchLitigationData}
                //               setIsClientDataUpdated={setLitigationDashboardDataUpdated}
                //               className="lit-defservice-block"
                //             />
                //           </>
                //         )}
                //         <DefendantPlaintiffBlock BlocksData={CardsData} />
                //       </div>
                //     </div>
                //     <div
                //       className="litigation-right content-right bg-white position-relative"
                //       // id="right-timeline"
                //     >
                //       <div className="right-calendar border-0 p-0 h-100">
                //         <LitigationTimeLines sol_events={litigationData?.sol_events} />
                //       </div>
                //     </div>
                //   </div>
                //   <div className="w-100 px-1">
                //     <LitigationActSummaryTable
                //       eventTypesData={eventTypesData}
                //       CaseData={CardsData}
                //       isBlocked={isBlocked}
                //     />
                //   </div>

                // </>
              )}
              {litigationTab === "discovery_tools" && (
                <>
                  <div
                    className="height-400 m-b-5"
                    style={{
                      overflowY: "auto",
                    }}
                  >
                    {Object.keys(templateStatus).length > 0 && (
                      <div
                        className="overflow-scroll buttonConfigs-layout invisible-scrollbar"
                        style={{ paddingLeft: "5px", paddingRight: "5px", paddingBottom: "5px" }}
                      >
                        {buttonConfigs.map(({ label, icon, type, onClick }, idx) => (
                          <button
                            key={idx}
                            type="button"
                            className={"event-type-button height-25 unselected"} // ${modalData?.type === type ? "selected" : "unselected"}
                            onClick={onClick ? onClick : () => handleOpenModal(type, label, icon)}
                          >
                            <i
                              className={`ic ic-19 ${type !== "Discovery" && !templateStatus[type] && "icon-grayscale"}  ${icon || "ic-default"} m-r-5`}
                            />
                            <span
                              className={`text-nowrap ${type !== "Discovery" && !templateStatus[type] && "text-primary-50"}`}
                            >
                              {label}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}

                    <div className="litigation-sec-action-bar">
                      <div className="w-100" style={{ height: "25px" }}>
                        <div className="d-flex justify-content-center align-items-center height-25">
                          <span className="text-center d-flex justify-content-center align-items-center text-uppercase color-white fw-bold height-25 p-t-0 p-b-0">
                            Litigation Document Drafts
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* Table */}
                    {/* Start */}
                    <div className="mt-2 table--no-card rounded-0 border-0 w-100">
                      <table className="table table-borderless table-striped table-earning settlement-table">
                        <thead>
                          <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                            <th className="" />
                            <th className="text-center td-autosize">Name</th>
                            <th className="" />
                            {/* <th className="text-center td-autosize">Description</th>
                            <th className="" /> */}
                            <th className="text-center td-autosize">Litigation Act</th>
                            <th className="" />
                            <th className="text-center td-autosize">Action</th>
                          </tr>
                        </thead>
                        <tbody id="body-table mb-1">
                          {documentDraft?.map((documentDraft, index) => (
                            <tr key={documentDraft?.id} className="cursor-default">
                              <td className="text-center td-autosize" style={{ width: "35px" }}>
                                {index + 1}
                              </td>
                              {documentDraft?.for_court_form ? (
                                <td className="td-autosize" style={{ textAlign: "left" }}>
                                  <span
                                    style={{ position: "relative", top: "2px" }}
                                    className="ic ic-19 ic-court-form"
                                  />{" "}
                                  <span>
                                    {" "}
                                    {documentDraft?.for_court_form?.court_form_code ?? "-"}:
                                    {documentDraft?.for_court_form?.court_form_name}
                                  </span>
                                </td>
                              ) : (
                                <td className="td-autosize" style={{ textAlign: "left" }}>
                                  <span
                                    style={{ position: "relative", top: "2px" }}
                                    className="ic ic-19 edit-template-icon"
                                  />{" "}
                                  <span>
                                    {documentDraft?.name ?? "-"}: Set{" "}
                                    {documentDraft?.set_number ?? "-"}
                                    {documentDraft?.no_of_questions &&
                                      `, ${documentDraft?.no_of_questions} Questions Numbered ${documentDraft?.starting_number} - ${documentDraft?.ending_number}`}
                                  </span>
                                </td>
                              )}
                              <td className="" />
                              {/* {documentDraft?.for_court_form ? (
                                <td className="text-center td-autosize">
                                  {documentDraft?.for_court_form?.court_form_code}:{" "}
                                  {documentDraft?.for_court_form?.court_form_name}
                                </td>
                              ) : (
                                <td className="text-center td-autosize">
                                  Set {documentDraft?.set_number ?? "-"}
                                  {documentDraft?.no_of_questions &&
                                    `, ${documentDraft?.no_of_questions} Questions Numbered ${documentDraft?.starting_number} - ${documentDraft?.ending_number}`}
                                </td>
                              )} */}{" "}
                              <td className="td-autosize" style={{ textAlign: "left" }}>
                                {documentDraft?.for_litigation_act?.event_id?.event_name && (
                                  <span
                                    style={{ position: "relative", top: "2px" }}
                                    className="ic ic-19 ic-litigation"
                                  />
                                )}{" "}
                                <span>
                                  {documentDraft?.for_litigation_act?.event_id?.event_name}
                                </span>
                              </td>
                              <td className="" />
                              <td>
                                <span className="d-flex justify-content-center align-items-center">
                                  {documentDraft.for_doc && !documentDraft?.for_court_form ? (
                                    <button
                                      className="btn btn-primary height-25 d-flex mt-1 justify-content-center align-items-center"
                                      onClick={() => {
                                        handleEditButton(
                                          documentDraft?.for_doc?.id,
                                          documentDraft?.for_doc?.file_name
                                        );
                                      }}
                                    >
                                      {/*  */}
                                      Open Template Document
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-primary height-25 d-flex mt-1 justify-content-center align-items-center"
                                      onClick={() => {
                                        getDiscoveryData(documentDraft?.id);
                                      }}
                                    >
                                      Edit
                                    </button>
                                  )}

                                  {/* <button
                                    className="btn btn-danger height-25 d-flex ms-1 mt-1 justify-content-center align-items-center"
                                    onClick={() => {
                                      handleDeleteButton(documentDraft?.id);
                                    }}
                                  >
                                    Delete
                                  </button> */}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* End */}
                  </div>
                </>
              )}
              {litigationTab === "events" && (
                <div className="m-b-5">
                  <LitigationTab
                    litigation_obj={litigationData?.litigation}
                    eventTypesData={eventTypesData}
                    CaseData={CardsData}
                  />
                </div>
              )}
              {litigationTab === "courtForms" && <CourtFormPageTable instanceId={"0"} />}
              {litigationTab === "court_history" && <CourtHistoryTable />}
              {litigationTab === "docs" && (
                <PageDocsTab
                  key={`${clientId}-${currentCaseId}`}
                  pageId={19}
                  pageName={pageObject?.name || "Litigation"}
                  pageIcon={pageObject?.page_icon}
                />
              )}
              {litigationTab === "photo" && (
                <PhotoTab pageId={19} pageName={pageObject?.name || "Litigation"} />
              )}
              <NotesSectionDashboard pageName={"Litigation"} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {showActPopup && (
        <AddLitigationActPopup
          showPopup={showActPopup}
          handleClose={handleClosePopup}
          litigationDetail={CardsData}
          eventTypesData={eventTypesData}
          isBlocked={isBlocked}
        />
      )}

      {modalData?.type === "Discovery" ? (
        <DiscoveryLitigationModal
          show={true}
          getDocumentDraft={getDocumentDraft}
          onClose={handleCloseModal}
          discoveryData={discoveryData}
          handleEditButton={handleEditButton}
          handleFinalizeButton={handleFinalizeButton}
          docDetails={docDetails}
          draftID={draftID}
          modalData={modalData}
          litigationDetail={CardsData}
        />
      ) : modalData?.type === "Interrogatories" ? (
        <DiscoveryEditModal
          show={true}
          getDocumentDraft={getDocumentDraft}
          onClose={handleCloseModal}
          discoveryData={discoveryData}
          handleEditButton={handleEditButton}
          handleFinalizeButton={handleFinalizeButton}
          docDetails={docDetails}
          draftID={draftID}
          modalData={modalData}
          litigationDetail={CardsData}
          handleDeleteButton={handleDeleteButton}
        />
      ) : (
        modalData &&
        (templateStatus[modalData?.type] ? (
          <TemplatesLitigationModal
            show={true}
            onClose={handleCloseModal}
            litigationDetail={CardsData}
            modalData={modalData}
          />
        ) : (
          <NoTemplateModal show={true} onClose={handleCloseModal} />
        ))
      )}

      {/* {
        <NotEnablePopUp
          confirmPopUp={validationPopUp}
          handleClose={handleValidationPopUp}
          title={validationText}
        />
      } */}
      {/* {showCourtForm && (
        <CourtForm
          show={true}
          handleClose={() => setShowCourtForm(false)}
          PageEntity="litigation"
          instanceId={"0"}
          // instanceId={litigation_obj?.id}
        />
      )} */}
    </>
  );
}

export default React.memo(LitigationPage);
